import React, { FC } from 'react';

import LogoComponent from '../../../../../../atoms/Logo';
import { IPrizeMerchant } from '../../../../../../types';

import styles from './index.module.sass';

interface LogoProps {
  merchant: IPrizeMerchant;
}

const Logo: FC<LogoProps> = ({ merchant: { domain, logoImageUrl, name }}) => (
  <LogoComponent
    className={styles.logo}
    image={logoImageUrl}
    link={domain}
    name={name}
    width={90}
  />
);

export default Logo;
